import React, { Component } from 'react';
import axios from 'axios';
import { getToken } from '../../functions/app_functions.js';
import ForminputText from '../forminput/forminput_text.js';
import Video from "../../media/images/home/home_benefits.mp4"


export default class CreateTrip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: 1,
            title: "",
            category: [],
            size: []
        };

        this.setPage = this.setPage.bind(this);
        this.setFormValue = this.setFormValue.bind(this);
        this.toggleTripCategory = this.toggleTripCategory.bind(this);
        this.toggleTargetGroup = this.toggleTargetGroup.bind(this);
        this.verifyTripData = this.verifyTripData.bind(this);
        this.submitCreateTrip = this.submitCreateTrip.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }


    setPage(page) {
        this.setState({ page: page });
    }


    setFormValue(label, value) {
        this.setState({
            [label]: value
        });
    }


    toggleTripCategory(category) {
        try {
            var categories = this.state.category;
            if (categories.includes(category)) {
                if (categories.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 trip category.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = categories.indexOf(category);
                if (index !== -1) {
                    categories.splice(index, 1);
                }
            } else {
                categories.push(category);
            }
            this.setState({
                category: categories
            });
        } catch (error) {
            console.log(error);
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_toggleTripCategory");
        }
    }


    toggleTargetGroup(target) {
        try {
            var targets = this.state.size;
            if (targets.includes(target)) {
                if (targets.length <= 1) {
                    var name = "Error";
                    var message = "You need to select at least 1 target group.";
                    this.props.setError(name, message);
                    return false;
                }
                var index = targets.indexOf(target);
                if (index !== -1) {
                    targets.splice(index, 1);
                }
            } else {
                targets.push(target);
            }
            this.setState({
                size: targets
            });
        } catch (error) {
            console.log(error);
            // Track error
            var name = "Client error";
            var message = "Could not update trip data.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_toggleTargetGroup");
        }
    }


    verifyTripData(data_in) {
        const data = data_in;
        var return_value = data;
        try {
            // Check if title is set
            if (!data.title || data.title.length < 5 || data.title.length > 200) {
                var name = "";
                var message = "Your trip title needs to be between 5 and 200 characters.";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
            // Check if category is set
            if (!data.category || data.category.length < 1) {
                var name = "";
                var message = "Your trip needs to have at least 1 category attribute (e.g., adventure, beach, safari).";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
            // Check if target is set
            if (!data.target || data.target.length < 1) {
                var name = "";
                var message = "Your trip needs to have at least 1 target group (e.g., solo travelers, couples).";
                this.props.setError(name, message);
                return_value = false;
                return return_value;
            }
        } catch (error) {
            // Track error
            var name = "Website error";
            var message = "Could not verify data completeness. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_verifyTripData");
            return_value = false;
        } finally {
            return return_value;
        }
    }


    async submitCreateTrip(data) {
        this.props.setLoading();
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/createtrip", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: data,
                    user_id: this.state.user_id
                }),
            });
            // Process response
            response = await response.json();
            // Check token validity
            if ('error' in response && (response["error"] == "email")){
                // Track error
                var name = "Error";
                var message = "You need to verify your email before you can create a trip.";
                this.props.setError(name, message);
                this.props.unsetLoading();
            } else {
                // Process data
                var data = response.value;
                if (data.status) {
                    // Track event
                    this.props.logEvent("User activity", "Trip created");
                    // Forward to trip page
                    var trip_id = data.trip_id;
                    this.props.goToPage("/trip/" + trip_id);
                    this.props.unsetLoading();
                } else {
                    // Track error
                    var name = "Server error";
                    var message = "Could not create trip. Please try again later.";
                    this.props.setError(name, message);
                    // Track event
                    this.props.logEvent("Client error", "Createtrip_submitCreateTrip");
                    this.props.unsetLoading();
                }
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not create trip. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Createtrip_submitCreateTrip");
            this.props.unsetLoading();
        }
    }


    submitForm() {
        const data = {
            title: this.state.title,
            category: this.state.category,
            target: this.state.size
        }
        const validated = this.verifyTripData(data);
        if (validated) {
            this.submitCreateTrip(validated);
        }
    }


    render() {

        return (
            <div className="content-container">
                <div className="form-container form-container--with-background">
                    <div className="form__background form__background--trip">
                        {/* <video width="320" height="240" className="home__valueprop__video-inner" autoPlay muted controls={false}>
                            <source src={Video} category="video/mp4" />
                        </video> */}
                    </div>
                    <div className="form__overlay"></div>
                    <div className="form__popup-container">
                        <div className="form__popup">

                            {this.state.page === 1 &&
                                <div className="trip__popup__title text-subtitle">
                                    We only need the basics to get started
                                </div>
                            }

                            {this.state.page === 2 &&
                                <div className="trip__popup__title text-subtitle">
                                    Next we'll define the settings for this trip
                                </div>
                            }

                            {this.state.page === 1 &&
                                <div className="trip__popup__section">
                                    {/* <div className="trip__popup__element">
                                    Please provide a title and indicate the category of trip you will create an itinerary for. You will be able to add details later.  
                                </div> */}
                                    <div className="trip__popup__element">
                                        {<div className="trip__popup__element__label text-subtitle">
                                            Title
                                        </div>}
                                        <div className="trip__popup__element__content">
                                            <ForminputText
                                                name={"title"}
                                                label={""}
                                                default_value={this.state.title}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                                note={"Give your trip a title with 5-200 characters."}
                                            />
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Trip category
                                        </div>
                                        <div className="trip__popup__element__content trip__labelbar">
                                            {this.props.trip_categories.map((category, i) => (
                                                <div key={i} onClick={() => this.toggleTripCategory(category)} className={"trip__label" + (this.state.category.includes(category) ? " trip__label--selected" : " trip__label--unselected")}>
                                                    {category}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="trip__popup__element">
                                        <div className="trip__popup__element__label text-subtitle">
                                            Target group
                                        </div>
                                        <div className="trip__popup__element__content trip__labelbar">
                                            {this.props.trip_targets.map((target, i) => (
                                                <div key={i} onClick={() => this.toggleTargetGroup(target)} className={"trip__label" + (this.state.size.includes(target) ? " trip__label--selected" : " trip__label--unselected")}>
                                                    {target}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {this.state.page === 2 &&
                                <div className="trip__popup__section">
                                    <div className="trip__popup__element">
                                        {<div className="trip__popup__element__label text-subtitle">
                                            Do you want to make this trip publicly available?
                                        </div>}
                                        <div className="trip__popup__element__content">
                                            Switch
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__buttonbox">
                                    {/* <button disabled={this.state.page === 1 ? true : false} onClick={() => this.setPage(this.state.page - 1)} className={"button" + (this.state.page === 1 ? " button-inactive" : " button-primary-light")}>
                                        Go back
                                    </button> */}
                                    {this.state.page !== 1 &&
                                        <button onClick={() => this.setPage(this.state.page + 1)} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Continue
                                        </button>
                                    }
                                    {this.state.page === 1 &&
                                        <button onClick={this.submitForm} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Create trip
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
